import { useContext } from 'react';
import { ConfigContext } from 'components/ConfigGuard';
import { AccountPortalExperiences } from 'store/types/SiteConfig';

/**
 * Account Portal experience flags from the site configuration. An enabled
 * experience links out to the Account Portal; a disabled one keeps the user
 * on the legacy page. All experiences report disabled until the site config
 * has loaded (or if it could not be read), so callers never link to an
 * unavailable experience.
 */
const useAccountPortalExperiences = (): AccountPortalExperiences => {
  const { accountPortalExperiences } = useContext(ConfigContext);
  return accountPortalExperiences;
};

export default useAccountPortalExperiences;
